import React, { useEffect } from "react";
import { applyActionCode } from "firebase/auth";
import { auth } from "../firebase";

const EmailVerify = () => {
  const firebaseEmailConfig = () => {
    // TODO: Implement getQueryParam()
    function getQueryParam(name) {
      const regex = new RegExp("[?&]" + name + "=([^&#]*)", "i");
      const result = regex.exec(window.location.search);
      return result ? decodeURIComponent(result[1]) : null;
    }

    const userAgent = navigator.userAgent;

    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    // const isDesktop = !isAndroid && !isIOS;

    const messageElement = document.getElementById("email-verification-msg");

    function handleVerifyEmail(auth, actionCode, continueUrl, lang) {
      // Localize the UI to the selected language as determined by the lang
      // parameter.
      // Try to apply the email verification code.
      applyActionCode(auth, actionCode)
        .then((resp) => {
          // Email address has been verified.
          // TODO: Display a confirmation message to the user.
          // You could also provide the user with a link back to the app.
          // TODO: If a continue URL is available, display a button which on
          // click redirects the user back to the app via continueUrl with
          // additional state determined from that URL's parameters.
          messageElement.innerHTML = "Your email has been verified!";
          try {
            if (isAndroid) {
              window.location = `searchme://SearchMeScreen?oobCode=${actionCode}`;
            }else if (isIOS) {
              window.location = `searchme://SearchMeScreen?oobCode=${actionCode}`;
            }else{
              messageElement.innerHTML = "Your email has been verified!";
            }
          } catch (error) {
            if (isAndroid) {
              window.location = `https://play.google.com/store/apps/details?id=com.geevertech.searchme`;
            }else if (isIOS) {
              window.location = `https://apps.apple.com/app/searchme/id6746272389`;
            }else{
              messageElement.innerHTML = "Your email has been verified!";
            }
          }
          //   console.log(resp);
        })
        .catch((error) => {
          // Code is invalid or expired. Ask the user to verify their email address
          // again.
          messageElement.innerHTML =
            "Your email could not be verified!<br/>Resend verification message and try again.";
          //   console.log(error);
        });
    }

    // Get the action to complete.
    const mode = getQueryParam("mode");
    // Get the one-time code from the query parameter.
    const actionCode = getQueryParam("oobCode");
    // (Optional) Get the continue URL from the query parameter if available.
    const continueUrl = getQueryParam("continueUrl");
    // (Optional) Get the language code if available.
    const lang = getQueryParam("lang") || "en";

    // Handle the user management action.
    switch (mode) {
      case "resetPassword":
        // Display reset password handler and UI.
        // handleResetPassword(auth, actionCode, continueUrl, lang);
        break;
      case "recoverEmail":
        // Display email recovery handler and UI.
        // handleRecoverEmail(auth, actionCode, lang);
        break;
      case "verifyEmail":
        // Display email verification handler and UI.
        handleVerifyEmail(auth, actionCode, continueUrl, lang);
        break;
      default:
        // Error: invalid mode.
        messageElement.innerHTML = "Error...<br/>Can't verify email!";
    }
    if (!mode && !actionCode) {
      messageElement.innerHTML = "Error...<br/>Email not detected!";
    }
  };

  useEffect(() => {
    document.title = "SearchMe - Email Verification";
    firebaseEmailConfig();
  }, []);

  return (
    <div className="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
      <header className="mb-auto">
        <div>
          <img
            src="../logo/Logo.png"
            height="55"
            width="55"
            alt="SearchMe"
            className="mx-auto mb-0"
          />
        </div>
      </header>

      <main className="px-3">
        <h1 className="h1-search fw-bold">
          Search<span className="h1-me">Me</span>
        </h1>
        <div className="lead h1-search fw-bold" id="email-verification-msg">
          <div className="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <p className="lead h1-search py-2">
          Connecting local business owners and service providers to clients.
        </p>
      </main>

      <footer className="mt-auto h1-search">
        <p>&copy; SearchMe 2025</p>
      </footer>
    </div>
  );
};

export default EmailVerify;
